import React from 'react';
import { useEditorStore } from '../store/editorStore';
import { X } from 'lucide-react';

const TabBar: React.FC = () => {
  const { tabs, activeFileId, setActiveFile, removeTab } = useEditorStore();

  const getLanguageColor = (language: string) => {
    const colors: Record<string, string> = {
      html: '#e34c26',
      css: '#1572b6',
      javascript: '#f7df1e',
      typescript: '#3178c6',
      json: '#292929'
    };
    return colors[language] || '#888';
  };

  return (
    <div className="flex bg-editor-panel border-b border-editor-border">
      {tabs.map((tab) => (
        <div
          key={tab.fileId}
          className={`flex items-center px-4 py-2 border-r border-editor-border cursor-pointer group hover:bg-editor-bg transition-colors ${
            activeFileId === tab.fileId ? 'bg-editor-bg border-b-2 border-blue-500' : ''
          }`}
          onClick={() => setActiveFile(tab.fileId)}
        >
          <div
            className="w-2 h-2 rounded-full mr-2"
            style={{ backgroundColor: getLanguageColor(tab.language) }}
          />
          <span className="text-sm text-gray-300 mr-2">{tab.name}</span>
          <button
            className="opacity-0 group-hover:opacity-100 hover:bg-gray-600 rounded p-1 transition-opacity"
            onClick={(e) => {
              e.stopPropagation();
              removeTab(tab.fileId);
            }}
          >
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default TabBar;
